import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhopalcab() {



  const cardData =
  {
    keyword: 'Mumbai to Bhopal Cab',
    heading: 'Shambhu Cabs: Mumbai to Bhopal Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Bhopal Cab services, providing safe, comfortable, and hassle-free long-distance travel for families, business travelers, corporate groups, and individuals. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey from Mumbai to Bhopal with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 customer support, Shambhu Cabs makes intercity travel stress-free and dependable. For a comfortable, safe, and trustworthy Mumbai to Bhopal cab experience, Shambhu Cabs is your trusted travel partner.',

    top: 'Top Places to Visit in Bhopal with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Upper Lake (Bada Talab)",
    "description": "The Upper Lake, also known as Bada Talab, is the largest lake in Bhopal and a historical marvel built by Raja Bhoj nearly a thousand years ago. Surrounded by lush greenery, walking paths, and picnic spots, it is ideal for boating, kayaking, and enjoying serene sunsets. The lake attracts nature lovers, photographers, and families seeking peaceful leisure. Migratory birds often visit during winter, adding to the charm. Its calm waters and scenic views make it the heart of Bhopal’s natural beauty."
  },
  {
    "title": "Lower Lake",
    "description": "The Lower Lake, also called Chhota Talab, lies adjacent to the Upper Lake and together they form a picturesque waterbody in the city. The lakefront is dotted with ghats, gardens, and temples, offering a peaceful environment for walks, meditation, and birdwatching. Visitors can enjoy boat rides, relax by the water, and capture the reflection of city lights on the calm surface. It is a serene escape amid Bhopal’s urban landscape."
  },
  {
    "title": "Taj-ul-Masajid",
    "description": "Taj-ul-Masajid is one of India’s largest mosques, renowned for its grand Mughal-inspired architecture. Its pink façade, massive domes, minarets, and intricately carved arches create a majestic appearance. The mosque offers a serene spiritual experience and is visited by worshippers and tourists alike. Evening visits are particularly mesmerizing as the setting sun casts warm light on its vast courtyard. It stands as a symbol of Bhopal’s rich Islamic heritage."
  },
  {
    "title": "Bhimbetka Rock Shelters",
    "description": "A UNESCO World Heritage Site, Bhimbetka Rock Shelters feature prehistoric cave paintings dating back over 30,000 years. Depicting hunting scenes, daily life, and rituals, the ancient artwork is carved on natural rock formations surrounded by forests. Visitors can explore the caves via guided trails, witnessing the fusion of history, culture, and nature. It is a significant archaeological and tourist site that offers a fascinating glimpse into early human civilization."
  },
  {
    "title": "Sanchi Stupa",
    "description": "Sanchi Stupa, located about 45 km from Bhopal, is a UNESCO World Heritage Site and one of India’s oldest Buddhist monuments. Built during the reign of Emperor Ashoka in the 3rd century BCE, the stupas and intricately carved toranas narrate Buddhist teachings and Jataka tales. The tranquil environment, surrounding greenery, and historical significance make it a must-visit site for pilgrims, historians, and travelers seeking peace and cultural insight."
  },
  {
    "title": "Van Vihar National Park",
    "description": "Van Vihar National Park is a sprawling urban wildlife sanctuary situated near Upper Lake. It houses tigers, leopards, deer, and hundreds of bird species in open, naturalistic enclosures. Visitors can enjoy walking trails, cycling, safaris, and wildlife photography while experiencing a green escape within the city. The park is also home to peaceful picnic spots, making it an ideal destination for families and nature enthusiasts."
  },
  {
    "title": "Bharat Bhavan",
    "description": "Bharat Bhavan is a premier cultural center and art complex in Bhopal, featuring museums, galleries, an open-air theater, and spaces for performing arts. Designed by renowned architect Charles Correa, it overlooks scenic landscapes and hosts exhibitions, music performances, literary events, and cultural workshops. The center is a hub for artists, students, and tourists to experience India’s diverse artistic heritage in a serene and inspiring environment."
  },
  {
    "title": "State Museum Bhopal",
    "description": "The State Museum showcases Madhya Pradesh’s rich cultural, historical, and tribal heritage. Visitors can explore ancient sculptures, coins, manuscripts, paintings, tribal artifacts, and fossil displays. It offers insight into the region’s diverse history and artistic traditions. The museum is popular among students, historians, and tourists seeking educational and cultural enrichment."
  },
  {
    "title": "Indira Gandhi Rashtriya Manav Sangrahalaya (Tribal Museum)",
    "description": "The Tribal Museum, also called Manav Sangrahalaya, highlights India’s tribal cultures through life-sized installations, traditional houses, artifacts, and handicrafts. Visitors can witness tribal rituals, daily life, and indigenous art forms. The open-air galleries and educational displays create an immersive experience for tourists, students, and culture enthusiasts interested in learning about India’s rich indigenous heritage."
  },
  {
    "title": "Moti Masjid",
    "description": "Moti Masjid, built by Sikander Begum in the 19th century, is a charming white marble mosque located on a hill in Bhopal. Its serene ambiance, elegant architecture, and hilltop views make it a peaceful retreat for visitors. The mosque is less crowded, offering quiet reflection and a glimpse into Bhopal’s historical Islamic architecture and royal legacy."
  }
],



"services": [
  {
    "name": "Mumbai Bhopal Taxi Service",
    "description": "Mumbai Bhopal Taxi Service offers seamless long-distance travel between Mumbai and the capital city of Madhya Pradesh. With professional chauffeurs, well-maintained cars, and comfortable AC cabins, this service ensures a safe and hassle-free intercity journey. Whether travelling for family visits, tourism, medical needs, or official work, passengers enjoy smooth highway travel, on-time pickup, and complete convenience throughout the long route covering major highways and scenic stretches."
  },
  {
    "name": "Bhopal From Mumbai Cab",
    "description": "Bhopal From Mumbai Cab provides reliable and comfortable cab travel from Mumbai directly to Bhopal with doorstep pickup and flexible drop locations across the city. This service is designed for travellers seeking an easy intercity travel solution without the stress of train or flight schedules. With transparent pricing, multiple cab choices, and experienced long-route drivers, passengers enjoy a smooth and relaxed journey to Bhopal."
  },
  {
    "name": "One Way Cab Mumbai Bhopal",
    "description": "One Way Cab Mumbai Bhopal is a cost-effective travel option for those who need travel in one direction without returning to Mumbai. Ideal for relocations, long stays, business travel, or family visits, this service provides economical fares with premium comfort. Clean, air-conditioned cars and skilled chauffeurs ensure a safe and pleasant long-distance ride to Bhopal."
  },
  {
    "name": "Intercity Cab Mumbai to Bhopal",
    "description": "Intercity Cab Mumbai to Bhopal is a dedicated long-distance travel service designed for passengers who prefer private and comfortable road journeys. The service includes GPS-enabled vehicles, reliable drivers familiar with the Mumbai–Bhopal route, and smooth highway travel experience. Suitable for families, business travellers, tourists, and groups seeking dependable intercity transport."
  },
  {
    "name": "Affordable Taxi Mumbai Bhopal",
    "description": "Affordable Taxi Mumbai Bhopal delivers budget-friendly travel without compromising on comfort or safety. This service is ideal for travellers searching for economical long-distance cab options. With transparent pricing, no hidden charges, fuel-efficient cars, and courteous drivers, passengers receive an excellent value-for-money travel experience to Bhopal."
  },
  {
    "name": "Long Distance Cab Mumbai Bhopal",
    "description": "Long Distance Cab Mumbai Bhopal provides a smooth, convenient, and safe travel experience across state lines. Designed for extended journeys, the service uses comfortable, well-maintained cars suitable for long hours on the road. Professional long-route drivers ensure consistent driving quality, minimal fatigue, and safe handling of highways for stress-free long-distance travel."
  },
  {
    "name": "Mumbai Bhopal Car Rental",
    "description": "Mumbai Bhopal Car Rental offers sedans, SUVs, and premium cars for those planning travel to Bhopal. This service suits travellers who need full-trip flexibility, multi-day plans, sightseeing routes, or additional stops on the way. With hourly, daily, and trip-based rental options, customers enjoy a customized travel experience with professional chauffeurs."
  },
  {
    "name": "Premium Cab Mumbai Bhopal",
    "description": "Premium Cab Mumbai Bhopal provides a luxury travel option for passengers wanting superior comfort, plush seating, and high-end vehicles like Innova Crysta, Kia Carens, or premium sedans. Ideal for executives, business travellers, and families seeking extra comfort, this service ensures a smooth, stylish, and highly comfortable long-distance road journey."
  },
  {
    "name": "Sedan Cab Mumbai Bhopal",
    "description": "Sedan Cab Mumbai Bhopal provides economical and comfortable travel for small groups, couples, and solo travellers. Cars like Dzire, Etios, and similar sedans deliver smooth highway performance, AC comfort, and budget-friendly pricing. This service is ideal for long-distance travel with a good balance of comfort and affordability."
  },
  {
    "name": "SUV Cab Mumbai Bhopal",
    "description": "SUV Cab Mumbai Bhopal offers spacious and powerful vehicles suitable for families, groups, and travellers who prefer extra comfort during long journeys. SUVs like Innova, Ertiga, and Crysta ensure ample legroom, comfortable seating, and strong performance on highways. This service is ideal for luggage-heavy trips or long-distance tours."
  },
  {
    "name": "24x7 Taxi Mumbai Bhopal",
    "description": "24x7 Taxi Mumbai Bhopal ensures round-the-clock availability for travellers who need early morning, late-night, or last-minute travel arrangements. With reliable customer support, instant booking confirmations, and timely pickups at any hour, this service provides complete travel flexibility and convenience."
  },
  {
    "name": "Mumbai Bhopal Corporate Cab",
    "description": "Mumbai Bhopal Corporate Cab service is designed for business travellers, corporate teams, and official trips. With premium sedans, executive SUVs, trained chauffeurs, punctual service, and professional coordination, companies rely on this service for safe, comfortable, and high-standard long-distance business travel."
  },
  {
    "name": "Fastest Cab Mumbai Bhopal",
    "description": "Fastest Cab Mumbai Bhopal ensures the quickest and most time-efficient route selection for travellers who prioritize speed. Drivers are experienced with expressways and the best connecting highways, reducing travel duration without compromising safety. Ideal for urgent travel, emergency trips, and business schedules."
  },
  {
    "name": "Safe Travel Cab Mumbai Bhopal",
    "description": "Safe Travel Cab Mumbai Bhopal focuses on secure and comfortable long-distance travel. With GPS-enabled vehicles, background-verified drivers, and strict hygiene standards, passengers—especially solo travellers, senior citizens, and families—can enjoy a worry-free journey. Safety remains the top priority throughout the lengthy intercity route."
  },
  {
    "name": "AC Taxi Mumbai Bhopal",
    "description": "AC Taxi Mumbai Bhopal provides fully air-conditioned cars that ensure a cool and comfortable journey throughout the long-distance route. Ideal for travellers who want a relaxed ride despite long hours, this service offers smooth AC cabins, clean interiors, and well-maintained vehicles for ultimate comfort."
  },
  {
    "name": "Business Trip Cab Mumbai Bhopal",
    "description": "Business Trip Cab Mumbai Bhopal is specially crafted for professionals travelling for meetings, conferences, or official visits in Bhopal. Offering punctuality, premium comfort, laptop-friendly seating, and executive driver behaviour, this service is perfect for hassle-free and productive corporate travel."
  },
  {
    "name": "Best Cab Mumbai to Bhopal",
    "description": "Best Cab Mumbai to Bhopal delivers the highest quality travel experience with clean cars, excellent driver service, timely pickup, and smooth long-route driving. Passengers enjoy a comfortable, safe, and reliable journey. This top-rated service is ideal for families, professionals, tourists, and anyone seeking the best overall travel experience between Mumbai and Bhopal."
  }
],

"tableData": [
  ["Mumbai Bhopal Taxi Service", "Bhopal From Mumbai Cab"],
  ["One Way Cab Mumbai Bhopal", "Intercity Cab Mumbai to Bhopal"],
  ["Affordable Taxi Mumbai Bhopal", "Long Distance Cab Mumbai Bhopal"],
  ["Mumbai Bhopal Car Rental", "Premium Cab Mumbai Bhopal"],
  ["Sedan Cab Mumbai Bhopal", "SUV Cab Mumbai Bhopal"],
  ["24x7 Taxi Mumbai Bhopal", "Mumbai Bhopal Corporate Cab"],
  ["Fastest Cab Mumbai Bhopal", "Safe Travel Cab Mumbai Bhopal"],
  ["AC Taxi Mumbai Bhopal", "Business Trip Cab Mumbai Bhopal"],
  ["Best Cab Mumbai to Bhopal", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Bhopal Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Bhopal cab services, ideal for long-distance travel, business trips, family journeys, and comfortable intercity travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable journey from Mumbai to Bhopal."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are experienced in interstate routes, ensuring safe driving, timely travel, and a hassle-free Mumbai to Bhopal cab experience."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Bhopal cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, and any journey-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel solutions tailored to your Mumbai to Bhopal travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic long-distance travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Bhopal travel convenient, comfortable, and stress-free."
  }
]

























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Bhopal?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Bhopal, ensuring a safe and pleasant long-distance journey.',
  },
  {
    question: 'How can I book a cab from Mumbai to Bhopal?',
    answer: 'You can easily book a cab from Mumbai to Bhopal via our website, mobile app, or by contacting our 24x7 customer support team for a seamless booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Bhopal cab bookings?',
    answer: 'Shambhu Cabs offers a range of vehicles for your Mumbai to Bhopal journey, including sedans, SUVs, luxury cars, and Tempo Travellers for larger groups.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Bhopal journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the Mumbai to Bhopal route, ensuring a smooth and safe travel experience.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Bhopal trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points within Mumbai and Bhopal, making the trip convenient and flexible for you.',
  },
  {
    question: 'Is the Mumbai to Bhopal cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 service for the Mumbai to Bhopal route, allowing you to travel at any time according to your convenience.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Bhopal trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene protocols to ensure a safe and clean journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Bhopal cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for Mumbai to Bhopal cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Bhopal trip?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey from Mumbai to Bhopal.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vishal Gupta',
    feedback: 'Our trip from Mumbai to Bhopal was amazing with Shambhu Cabs. The driver was punctual, the car was well-maintained, and we had a smooth and comfortable journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Joshi',
    feedback: 'Highly recommend Shambhu Cabs for long-distance trips like Mumbai to Bhopal. Great service, reliable drivers, and easy booking process.',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Bhopal Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-bhopal-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Bhopal cab services. Book affordable, premium, SUV, and sedan cabs for one-way, round trip, corporate, or business travel, available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "910",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-bhopal-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Bhopal Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Bhopal cab services with Shambhu Cabs. Affordable and premium cabs including SUV, sedan, corporate travel, business trips, and 24×7 service."
  />

  <meta
    name="keywords"
    content="Mumbai Bhopal Taxi Service, Bhopal From Mumbai Cab, One Way Cab Mumbai Bhopal, Intercity Cab Mumbai to Bhopal, Affordable Taxi Mumbai Bhopal, Long Distance Cab Mumbai Bhopal, Mumbai Bhopal Car Rental, Premium Cab Mumbai Bhopal, Sedan Cab Mumbai Bhopal, SUV Cab Mumbai Bhopal, 24x7 Taxi Mumbai Bhopal, Mumbai Bhopal Corporate Cab, Fastest Cab Mumbai Bhopal, Safe Travel Cab Mumbai Bhopal, AC Taxi Mumbai Bhopal, Business Trip Cab Mumbai Bhopal, Best Cab Mumbai to Bhopal"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhopalcab;